var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-switch',{attrs:{"active-text":"New Dashboard","inactive-text":"Old Dashboard"},model:{value:(_vm.isUsingNewDashboard),callback:function ($$v) {_vm.isUsingNewDashboard=$$v},expression:"isUsingNewDashboard"}}),(!_vm.isUsingNewDashboard)?_c('div',[_c('OldDashboard')],1):_c('div',[_c('NewDashboard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }